
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/casos/grupo-avenida",
      function () {
        return require("private-next-pages/[locale]/casos/grupo-avenida.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/casos/grupo-avenida"])
      });
    }
  